import { FC } from 'react'
import { Description, VStack } from '@revolut-internal/ui-kit'

import { AiDebugProcess, TraceActionClient } from 'lib/apiClient'

import { OpenAIChat } from '../Trace/OpenAIChat'
import { PtolemySearchLinks } from '../Trace/PtolemySearchLinks'
import { ParamsTable } from '../Trace/ParamsTable'

type Props = AiDebugProcess['traces'][number]

export const TraceAction: FC<Props> = props => {
  if (props.client === TraceActionClient.OpenAIChat) {
    return <OpenAIChat {...props} />
  }

  return (
    <VStack space="s-12">
      {props.client === TraceActionClient.PtolemySearchClient && (
        <VStack space="s-8">
          <PtolemySearchLinks data={props.clientOutput.data} />
        </VStack>
      )}

      <VStack space="s-12">
        <Description>Client input:</Description>
        <ParamsTable
          data={props.humanReadableInput ?? props.clientInput}
          markdown={Boolean(props.humanReadableInput)}
          chatUiRenderMethod={
            props.client === TraceActionClient.OpenAIModerator ||
            props.client === TraceActionClient.ModerationClient
          }
        />
      </VStack>

      <VStack space="s-12">
        <Description>Client output:</Description>
        <ParamsTable
          data={props.humanReadableOutput ?? props.clientOutput}
          markdown={Boolean(props.humanReadableOutput)}
        />
      </VStack>
    </VStack>
  )
}
